import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { WaitEmailNodeData } from '../../../node-edit.type';

@Component({
  selector: 'edit-wait-email',
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
  ],
  templateUrl: './edit-wait-email.component.html',
  styleUrl: './edit-wait-email.component.scss',
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditWaitEmailComponent,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditWaitEmailComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<WaitEmailNodeData>>();
  public disableForm = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  public form!: UntypedFormGroup;

  public ngOnInit(): void {
    const timeoutS = this.selectedNodeForEdit()?.data?.timeoutS ?? null;

    this.form = this.fb.group({
      name: [
        {
          value: this.selectedNodeForEdit()?.data?.name ??
            this.translateService.instant('FLOW_CHART.NODES.WAIT_EMAIL.NAME'),
          disabled: this.disableForm(),
        },
        [Validators.required],
      ],
      timeoutS: [{
        value: timeoutS,
        disabled: this.disableForm(),
      }, [Validators.required]],
    });
  }
}
